(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ClusterFranchiserFormController', ClusterFranchiserFormController)

    /** @ngInject */
    function ClusterFranchiserFormController($state, $stateParams, LoadingHelper, UtilHelper, sweetAlert, ClusterService) {
        const vm = this;
        const clusterId = $stateParams.clusterId;

        vm.saveCluster = () => {
            LoadingHelper.startLoading('.loading-holder');

            if (!vm.clusterData.Id) {
                ClusterService
                    .post(vm.clusterData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let clusterData = {
                    Id: clusterId,
                    ExternalCode: vm.clusterData.ExternalCode,
                    Description: vm.clusterData.Description
                };

                ClusterService
                    .put(clusterData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteCluster = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    ClusterService
                        .deleteData(clusterId)
                        .then(() => {
                            $state.go('app.franchiser-clusters-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getCluster() {
            if (!clusterId)
                return;

            LoadingHelper.startLoading('.loading-holder');

            ClusterService
                .get(clusterId)
                .then(success => {
                    vm.clusterData = success;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                vm.clusterData = success;

                $state.go('app.franchiser-clusters-edit', {
                    clusterId: vm.clusterData.Id
                }, {
                    notify: false
                });

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function init() {
            vm.clusterData = {};

            getCluster();
        }
    }
}());